import React from 'react';

import { annotationIconsList } from 'react-scale/components/website/big/content/icons/AnnotationIcons';

const AnnotationName = ({ icon, name }) => {
  const Icon = annotationIconsList[icon];
  return (
    <h3 className="text-sm uppercase tracking-widest py-6 text-magenta-dark flex items-center justify-center">
      <span className="h-6 w-6 mr-2 block">
        <Icon fill="#C634C3" />
      </span>
      {name}
    </h3>
  );
};

AnnotationName.defaultProps = {
  icon: 'ner',
  name: 'Named Entity Recognition'
};

export default AnnotationName;
